import { render, staticRenderFns } from "./AddSaved.vue?vue&type=template&id=217a4a60&scoped=true"
import script from "./AddSaved.vue?vue&type=script&lang=js"
export * from "./AddSaved.vue?vue&type=script&lang=js"
import style0 from "./AddSaved.vue?vue&type=style&index=0&id=217a4a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217a4a60",
  null
  
)

export default component.exports